export default __webpack_public_path__ + "static/media/12.574287d0.jpg";